import { Calendar } from "primereact/calendar";
import React from "react";
import { FormSectionElements, FormSubSections } from "../../entities/formTemplateDataType";
import XMLParser from "../../utilities/XMLParser";
import classNames from 'classnames';
import FormValidationUtils from "../../utilities/FormValidationUtils";
import { LiveValidationErrMsg } from "../live-validation-errMsg/LiveValidationErrMsg";
import Utils from "../../utilities/Utils";
import { getAppId, getRootComponent } from "../../utilities/ElementUtils";
import { getUserProfileFromSession } from "../../services/CxpProfileService";
import axios from "axios";
import DataUtils from "../../utilities/DataUtils";
import ReCaptchaV3 from "../captcha/CaptchComponent";
import ReCaptchaButton from "../captcha/captcha-button";
import { getEnvVar, SCRIPT_ENV } from "../../config/RuntimeConfig";
import SessionStorageService from "../../services/SessionStorageService";
import { setBaseHeaders } from "../../utilities/submitUtils";
import { APIKey } from "../../entities/formTemplateDataType";
import { TOKEN_TYPE } from "../../entities/Constants";


interface Props {
  field: FormSectionElements;
  isEng: boolean;
  callback;
  returnIndex?: number;
  callbackValidate?: (errors: any) => void;
  callbackStepIndex?: (index: number, returnIndex?: number) => void;
}

interface State {
  apiAttempts: number;

}
export class SubmitButtonComponent extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = {
      apiAttempts: 0
    };
  }

  arrayToString=(_a)=> {
    if (Array.isArray(_a)) {
      return _a.join(' '); 
    } else {
      return [_a]
    }
  }


  handleSecureButtonClick = async (token: string) => {
    let field=this.props.field;
    let section = field.parent.parent;
    const userProfile = getUserProfileFromSession();
    const maxAttempts = field.SubmitButton?.maxApiAttempts || 1;

    if (this.state.apiAttempts >= maxAttempts) {
      console.log(`Maximum API attempts (${maxAttempts}) reached`);
      
      // Redirect to error page immediately
      if (field.SubmitButton?.apiErrorRedirectPage) {
        this.redirectToErrorPage(field);
      }
      return;
    }

    // FormValidationUtils.runJavascript(this.props.field);

    field.Value = null;
    FormValidationUtils.resetSectionValidation(section);
    const invalidControlList = FormValidationUtils.invalidControls(section);
    if (invalidControlList.length > 0) {
        this.props.callbackValidate(invalidControlList);
        return;
    }    
    const api = field.Recaptcha?.api;
    const programContainer=getRootComponent(field);
    const entity = DataUtils.collectFormValue(programContainer);
    entity.language = this.props.isEng ? "EN" : "FR";
    entity.userId= userProfile?.userId
    entity.token = token;

    if (programContainer.AuthRequired == 'ps' || programContainer.AuthRequired == 'bps') {
      entity.publicSecureUserId = programContainer.Profile?.userId;
    }

    const apiKeyKey = field.ApiKeyKey || field.SubmitButton?.apiKeyKey;
    const apiKeyValue = field.ApiKeyValue || field.SubmitButton?.apiKeyValue;
    const apiKey: APIKey =
      apiKeyKey && apiKeyValue
        ? { key: apiKeyKey, value: apiKeyValue }
        : programContainer.ApiKeyKey && programContainer.ApiKeyValue
        ? { key: programContainer.ApiKeyKey, value: programContainer.ApiKeyValue }
        : null;

    const authMode = programContainer.AuthRequired?.toLowerCase();
    const authToken = authMode === 'ps'
      ? (SessionStorageService.getPSToken() ?? programContainer.Profile?.token)
      : authMode === 'bps'
      ? (SessionStorageService.getBPSToken() ?? programContainer.Profile?.token)
      : authMode === 'ad'
      ? (SessionStorageService.getAccessToken(TOKEN_TYPE.API) ?? programContainer.Profile?.token)
      : null;
    const headers = setBaseHeaders('application/json', authToken, apiKey);

    this.setState({ apiAttempts: this.state.apiAttempts + 1 });

    axios.post(api, entity, { headers })
      .then(response => {
        this.setState({ apiAttempts: 0 });
        field.Value = response.data;
        field.Valid = true;

        if (this.props.field.StepperScript) {
          const customJSFunc = eval(`(${this.props.field.StepperScript})`);
          customJSFunc((index) => {
            let destination = index;
            if (this.props.returnIndex!=null) {
              destination = this.props.returnIndex;
              if (this.props.callbackStepIndex)
                this.props.callbackStepIndex(destination);
            } else {
              if (typeof destination === "string") {
                const root = getRootComponent(this.props.field);
                const foundSection = root.ListOfFormSections.find(section => section.ENUTitle == destination);
                const indexNum = root.ListOfFormSections.indexOf(foundSection);
                if (this.props.callbackStepIndex)
                this.props.callbackStepIndex(indexNum)
              } else {
                if (this.props.callbackStepIndex)
                this.props.callbackStepIndex(destination);
              }
            }
          }, response.data);
        }
        this.props.callback(getRootComponent(field));
      })
      .catch(error => {
        console.log("error");
        field.Valid = false;

        if (this.state.apiAttempts >= maxAttempts) {
          console.log(`Maximum API attempts (${maxAttempts}) reached after failure`);
          this.redirectToErrorPage(field);
        }
        this.props.callback(getRootComponent(field));
      });
    
  }

  redirectToErrorPage = (field: FormSectionElements) => {
    if (field.SubmitButton?.apiErrorRedirectPage) {
      const errorRedirectPage = field.SubmitButton.apiErrorRedirectPage;
      const root = getRootComponent(this.props.field);
      
      console.log("Redirecting to error page due to maximum attempts reached");
      
      if (root && root.ListOfFormSections) {
        const sectionBySequence = root.ListOfFormSections.find(section => section.Sequence === errorRedirectPage);
        if (sectionBySequence) {
          const sectionIndex = root.ListOfFormSections.indexOf(sectionBySequence);
          if (this.props.callbackStepIndex) {
            this.props.callbackStepIndex(sectionIndex);
          }
        } else if (root.ListOfFormSections[errorRedirectPage]) {
          if (this.props.callbackStepIndex) {
            this.props.callbackStepIndex(errorRedirectPage);
          }
        } else {
          console.error(`Error redirect page ${errorRedirectPage} does not exist`);
          console.error("Available sections:", root.ListOfFormSections.map(s => ({ sequence: s.Sequence, index: root.ListOfFormSections.indexOf(s) })));
        }
      }
    }
  }

  render() {
    let field = this.props.field;
    let controlArray = [];
    let title = this.props.isEng ? this.props.field.ENUTitle : this.props.field.FRATitle;
    const maxAttempts = field.SubmitButton?.maxApiAttempts || 1;
    const attemptsRemaining = maxAttempts - this.state.apiAttempts;

    if (field.InitScript && Utils.isNotNullOrEmpty(field.InitScript)) {
      const customJSFunc = eval(`(${field.InitScript})`);
      try {
        customJSFunc(field, SCRIPT_ENV);
      } catch (ex) {
        console.log(ex);
      }

      if (field.Editable !== 'Y' || field.Visible == false) {
        return null;
      }
    }

    console.log("DISABLED_RECAPTCHA", getEnvVar('DISABLED_RECAPTCHA'))
    const lang = this.props.isEng ? 'en' : 'fr';
    const ClassName = "ontario-button " + this.arrayToString(this.props.field.ClassName);
    const isDisabled = this.state.apiAttempts >= maxAttempts;
    
    controlArray.push(
      <div style={{ textAlign: 'left' }} key={"button_" + field.parent.Sequence + "_" + field.Id}>
        
        {getEnvVar('DISABLED_RECAPTCHA') == 'false' && !isDisabled && (
          <ReCaptchaV3 lang={this.props.isEng ? 'en' : 'fr'}>
            <ReCaptchaButton 
              title={this.props.isEng ? field.ENUTitle : field.FRATitle} 
              id={`button_${field.parent.Sequence}_${field.Id}`}
              buttonHandler={this.handleSecureButtonClick} 
              action={this.props.field.Recaptcha?.action}>
              <div dangerouslySetInnerHTML={{__html: field.Recaptcha?.content[lang]}}/>
            </ReCaptchaButton>
          </ReCaptchaV3>
        )}
        
        {getEnvVar('DISABLED_RECAPTCHA') == 'false' && isDisabled && (
          <button 
            className={ClassName}
            disabled={true}
            style={{ opacity: 0.5, cursor: 'not-allowed' }}>
            {this.props.isEng ? field.ENUTitle : field.FRATitle}
          </button>
        )}
      </div>
    );

    return controlArray;
  }
}